export const PERSONAL_SALE = {
  id: 'new-user-personal-campaign',
  type: 'PERSONAL',
  defaultDiscount: 50,
  assetPath: 'apples/editor/new-user-personal-campaign',
};
